import React from 'react';
import {Link} from 'react-router-dom';

import SocialComponent from './../reuse/social';
import { SubscribeForm } from './../reuse/form_subscription';

import {FooterLink, FooterExtLink, FooterSectionTitle} from './base';
import {CopyrightFooter, CompanyComponent, OtherProductsComponent, ReachComponent} from './common';
import SelfPromo from 'component/content/self_promo';


export function LoggedInFooter(props){
  return(
    <footer className={"gradient-dark"}>
      <div className="col"></div>
      <div className="col">
        <div className="text-white fa-pull-left  family-code ">
          <div className="pt-4 pb-2 uppercase text-spacing-2">
            <Link to="/">Home</Link>
            <span className="mx-2 text-white">|</span>
            <Link to="/legal/privacy">Privacy</Link>
            <span className="mx-2 text-white">|</span>
            <Link to="/legal/tos">Terms</Link>
          </div>
          <div className="pt-2 pb-4">
            © { new Date().getFullYear() } - <a className=" uppercase text-spacing-2" href="https://bytebeacon.com">ByteBeacon, Inc</a> - All rights reserved.
          </div>
        </div>
      </div>
      <div className="col"></div>
      <div className="col">
        <div className="fa-pull-right">
          <div className=" py-5">
          <SocialComponent />
          </div>
        </div>
      </div>
      <div className="col"></div>
    </footer>
  )
}


export function LandingFooter(props){
  const is_mobile = window.innerWidth < 1200;
  return(
    <footer>
      <div  className="p-1 pb-5 bg-footer box-shadow text-black-9">
        <div className="row">
          <div className="col-sm-5 px-0"><AboutComponent is_mobile={is_mobile} /></div>
          <div className="col-sm-2 px-0"><CompanyComponent is_mobile={is_mobile} /></div>
          <div className="col-sm-2 px-0"><DivShowComponent is_mobile={is_mobile} /></div>
          <div className="col-sm-3 px-0"><ReachComponent is_mobile={is_mobile} /></div>
        </div>
      </div>
      <SelfPromo />
      <CopyrightFooter padding={3} />
    </footer>
  )
}


function AboutComponent(props){
  return (
    <div className="">
      <div className="m-1">
        <h2 className="text-dark my-5 text-spacing-5 family-title">
          <img style={{height: "40px"}} className="hero mx-3" src="/static/images/cursor.svg" alt="Divshow product cursor" />
          <span className="text-dark">Div</span><span className="text-secondary">Show</span>
        </h2>
        {/* <FooterSectionTitleLarge title="About"/> */}
        <p className=" text-spacing-2">A new kind of presentation tool that helps you get your product offering across through on site presentations.</p>
        <p className=" text-spacing-2">There's no video, but there is a show!</p>
      </div>

      <hr className="highlight-white-4 white-bb-1-1"/>

      <div className="m-3">
        <SubscribeForm full_width={true} />
      </div>
    </div>
  )
}

function DivShowComponent(props){
  const is_mobile = props.is_mobile;
  return (
    <div className={" text-center" + ((is_mobile)? ' mx-3 px-3': " m-1")}>
      <FooterSectionTitle title="Get Started"/>
      <div className="group-vertical">
        <FooterLink to="/login" text="Login" />
        <FooterLink to="/how" text="How it works" />
        <FooterLink to="/use_cases" text="Use Cases" />
        <FooterLink to="/pricing" text="Pricing" />
        <FooterLink to="/faq" text="FAQ" />
      </div>
    </div>
  )
}
